<template>
    <div>
        <div class="row">
            <div class="col col-12">
                <div
                    class="card full-width-image-1"
                    :style="{ 'background-image': 'url(' + imageFileURL + ')' }"
                >
                    <div id="watermark" style="color: white; font-weight: 700">
                        <div class="row">
                            <div
                                class="col col-12 col-md-8 col-lg-7 opaqueness"
                            >
                                <h3>
                                    <strong style="color: white">{{
                                        event.title
                                    }}</strong>
                                </h3>
                                <div
                                    class="text-left"
                                    v-if="!event.remove_location"
                                >
                                    <p>
                                        <i
                                            class="fa fa-road"
                                            aria-hidden="true"
                                        ></i>
                                        {{ event.event_address.address1 }}
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-building"
                                            aria-hidden="true"
                                        ></i>
                                        {{ event.event_address.city }}
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-map-marker"
                                            aria-hidden="true"
                                        ></i>
                                        {{ event.event_address.postcode }}
                                    </p>
                                    <p v-if="event.event_address.county">
                                        <i
                                            class="fa fa-map-marker"
                                            aria-hidden="true"
                                        ></i>
                                        {{ event.event_address.county }}
                                    </p>
                                    <p v-if="event.event_address.country_code">
                                        <i
                                            class="fa fa-flag"
                                            aria-hidden="true"
                                        ></i>
                                        {{ countryName }}
                                    </p>
                                </div>

                                <div v-if="!datesEqual">
                                    <p>
                                        <i
                                            class="fa fa-calendar"
                                            aria-hidden="true"
                                        ></i>
                                        <strong>From: </strong>
                                        {{ event.datetimefrom | formatDate }} @
                                        {{ event.datetimefrom | formatTime }}
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-calendar"
                                            aria-hidden="true"
                                        ></i>
                                        <strong>To: </strong>
                                        {{ event.datetimeto | formatDate }} @
                                        {{ event.datetimeto | formatTime }}
                                    </p>
                                </div>

                                <div v-if="datesEqual">
                                    <p>
                                        <i
                                            class="fa fa-calendar"
                                            aria-hidden="true"
                                        ></i
                                        >{{ event.datetimefrom | formatDate }}
                                    </p>
                                    <p>
                                        <i
                                            class="fa fa-clock-o"
                                            aria-hidden="true"
                                        ></i
                                        >{{ event.datetimefrom | formatTime }} -
                                        {{ event.datetimeto | formatTime }}
                                        <span style="margin-left: 14%"> </span>
                                    </p>
                                </div>

                                <!-- Temp fix for Suzuki event-->
                                <div class="socials">
                                    <social-circles
                                        v-if="event.id != 2912"
                                        :event="event"
                                    ></social-circles>
                                </div>
                                <a
                                    :style="{
                                        background: event.buttoncolour,
                                        'border-color': event.buttoncolour,
                                    }"
                                    class="btn btn-sm btn-primary"
                                    :href="
                                        'mailto:' +
                                        event.organiser_email +
                                        '?Subject=Query%20about%20' +
                                        event.title
                                    "
                                >
                                    Email: {{ event.organiser }}</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row venue-event">
            <div class="col col-12 col-md-5 col-lg-4 col-xl-3 col-venue">
                <div class="card hg-topline" :style="topLineOverride">
                    <div class="card-body">
                        <img
                            v-if="event.image1"
                            class="img-fluid mb-3"
                            alt="Logo"
                            :src="logoFileURL"
                        />

                        <h6
                            v-if="!event.remove_location"
                            :style="{ color: event.phcolour }"
                        >
                            Venue - {{ event.location }}
                        </h6>

                        <div
                            style="
                                width: 100%;
                                height: 50%;
                                min-height: 225px;
                                margin-bottom: 10px;
                            "
                            v-if="
                                !event.international && !event.remove_location
                            "
                        >
                            <google-map
                                name="previewmap"
                                :postcode="event.event_address.postcode"
                            ></google-map>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col col-12 col-md-7 col-lg-8 col-xl-9 col-event">
                <div class="card hg-topline" :style="topLineOverride">
                    <div class="card-body">
                        <div
                            class="card-header"
                            style="
                                background-color: #fff !important;
                                border: 0;
                                padding: 0px;
                            "
                            :class="event.theme"
                        >
                            <h4
                                :style="{ color: event.phcolour }"
                                style="
                                    font-weight: bold;
                                    margin: 0;
                                    padding: 0 0 5px 0;
                                "
                            >
                                About the event
                            </h4>
                        </div>
                        <div id="test" style="padding: 0px">
                            <div
                                style="border: 0; padding: 0px"
                                :style="{ color: event.textcolour }"
                                v-html="eventDetailsModified"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import maps from './../../common/maps';
import moment from 'moment';
import socialCircles from './../common/social-circles.vue';
import countries from './../../book/common/countries';

export default {
    mixins: [countries],

    props: [
        'event',
        'lat',
        'lng',
        'imageBucket',
        'imageFileURL',
        'logoFileURL',
    ],

    data() {
        return {
            eventDetailsModified: '',
        };
    },

    created() {
        this.eventDetailsModified = this.event.details.replaceAll(
            '<p><br></p>',
            '<br>'
        );
    },

    computed: {
        showAddress() {
            return !this.event.remove_location && this.event.event_address;
        },

        countryName() {
            if (
                this.event.event_address &&
                this.event.event_address.country_code
            ) {
                return this.getCountryName(
                    this.event.event_address.country_code
                );
            } else {
                return '';
            }
        },

        topLineOverride() {
            return { borderTop: '4px solid ' + this.event.phcolour };
        },

        mailto() {
            return (
                'mailto:' +
                this.event.organiser_email +
                '?Subject=Query%20about%20' +
                this.event.title
            );
        },

        datesEqual() {
            return moment
                .parseZone(this.event.datetimefrom)
                .isSame(moment.parseZone(this.event.datetimeto), 'day');
        },
    },

    components: {
        'google-map': maps,
        'social-circles': socialCircles,
    },
};
</script>

<style scoped>
#watermark {
    padding: 15px 30px;
    text-align: left;
}
.opaqueness {
    background: rgba(0, 0, 0, 0.35);
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 0.8rem;
}
.opaqueness p {
    margin-bottom: 0.5rem;
}
.opaqueness p i.fa {
    width: 20px;
}
.socials {
    padding: 10px 0;
}

.full-width-image-1 {
    display: block;
    display: table;
    width: 100%;
    /*height: 24em;*/
    text-align: right;
    background: no-repeat center center scroll;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
    z-index: 99;
}

@media screen and (min-width: 768px) {
    .opaqueness {
        font-size: 1rem;
    }
}
</style>
